import { Link } from "react-router-dom";
import { AudioLines } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-muted/40 grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-primary/15 text-primary">
              <AudioLines size={20} strokeWidth={1.5} />
            </span>
            <span className="font-serif text-xl">VoiceMatrix AI</span>
          </div>
          <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
            Voice-frequency wellness mapping. Every report is a set of wellness risk
            indicators — not a medical diagnosis. Always confirm with your physician.
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Explore</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/products" className="text-secondary-foreground hover:text-primary transition-colors">Our Products</Link></li>
            <li><Link to="/workshops" className="text-secondary-foreground hover:text-primary transition-colors">Workshops</Link></li>
            <li><Link to="/testimonials" className="text-secondary-foreground hover:text-primary transition-colors">Testimonials</Link></li>
            <li><Link to="/team" className="text-secondary-foreground hover:text-primary transition-colors">Our Team</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Get started</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/register" className="text-secondary-foreground hover:text-primary transition-colors">Take a free scan</Link></li>
            <li><Link to="/book" className="text-secondary-foreground hover:text-primary transition-colors">Book an appointment</Link></li>
            <li><Link to="/contact" className="text-secondary-foreground hover:text-primary transition-colors">Contact us</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Legal</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacy" className="text-secondary-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-secondary-foreground hover:text-primary transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/refund" className="text-secondary-foreground hover:text-primary transition-colors">Refund Policy</Link></li>
            <li><Link to="/disclaimer" className="text-secondary-foreground hover:text-primary transition-colors">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-muted-foreground flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} VoiceMatrix AI. All rights reserved.</span>
          <span>Wellness screening for informational purposes only.</span>
        </div>
      </div>
    </footer>
  );
}